import { HeadCell } from 'shell/components/shared/table/types';
import * as yup from 'yup';
import { TerritorialAreaClient } from 'shell/view-models/territorial-area-client';

export const headCells: HeadCell<TerritorialAreaClient, keyof TerritorialAreaClient>[] = [
  {
    id: 'streetCode',
    label: 'Codice via',
  },
  {
    id: 'civicNumber',
    label: 'Civico',
  },
  {
    id: 'exponent',
    label: 'Esponente',
  },
  {
    id: 'territorialArea',
    label: 'Ambito territoriale',
  },
  {
    id: 'municipality',
    label: 'Municipio',
  },
  {
    id: 'block',
    label: 'Isolato',
  },
  {
    id: 'censusSection',
    label: 'Sez. censimento',
  },
  {
    id: 'zipCode',
    label: 'CAP',
  },
];

export const validationSchemaToponymyFilter = yup.object({
  streetName: yup.object().nullable().required('Campo obbligatorio'),
});
